// extracted by mini-css-extract-plugin
export default {"sign-up":"Signup_sign-up__f54Y3"};